import Colours from '@/utils/colours/colourUtils.js'

export default {
    ...Colours
}